export const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];
export const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function toMidnight(dateVal) {
  const d = new Date(dateVal);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function getDayEntry(date, schedule) {
  const t = date.getTime();
  for (const e of schedule) {
    const start = toMidnight(e.start_date).getTime();
    const end = toMidnight(e.end_date).getTime();
    if (t >= start && t <= end) return e;
  }
  return null;
}

export function scheduleType(entry) {
  return String(entry?.type || "").toLowerCase();
}

export function isSameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function toDateInput(d) {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`;
}

export function fmtDayLabel(date) {
  return date.toLocaleDateString("en-IN", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });
}

export function toMonthInput(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function fmtMonth(str) {
  if (!str) return "";
  const [y, m] = str.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}
